var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoWater(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 89.718,
    height: 89.718,
    viewBox: "0 0 89.718 89.718",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_water",
    transform: "translate(-306 -896)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6451",
    "data-name": "Rectangle 6451",
    width: 89.718,
    height: 89.718,
    transform: "translate(306 896)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8216",
    "data-name": "Group 8216",
    transform: "translate(325.275 828.285)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19830",
    "data-name": "Path 19830",
    d: "M25.04,146.552a22.179,22.179,0,0,1-4.368-.423A25.194,25.194,0,0,1,.5,121.473C.5,106.4,14.919,87.942,21.118,80.709a5.953,5.953,0,0,1,9.017-.094c8.171,9.088,33.2,40.177,12.563,58.7a26.815,26.815,0,0,1-17.658,7.233Zm.681-63.259a1.453,1.453,0,0,0-1.009.47C18.817,90.6,5.2,107.9,5.2,121.473a20.5,20.5,0,0,0,16.437,20.053,21.131,21.131,0,0,0,18.056-5.612C57.091,120.206,34.22,92,26.776,83.739h0a1.36,1.36,0,0,0-1.08-.446Z",
    transform: "translate(0 0)",
    fill: "#0595f0",
    stroke: "#0595f0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19831",
    "data-name": "Path 19831",
    d: "M77.37,406.24a2.348,2.348,0,0,1-2.559,2.348,18.127,18.127,0,0,1-15.334-15.263,2.371,2.371,0,1,1,4.7-.657,13.48,13.48,0,0,0,11.271,11.271,2.207,2.207,0,0,1,1.879,2.184Z",
    transform: "translate(-51.039 -270.161)",
    fill: "#0595f0",
    stroke: "#0595f0",
    strokeWidth: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoWater);
export default __webpack_public_path__ + "static/media/ico_water.de98d2682354ff02638dbedd21fe12b5.svg";
export { ForwardRef as ReactComponent };